// import React, { useState } from "react";
// import { Box, Tabs, Tab, Typography, Paper, Container } from "@mui/material";
// import { Dashboard, Settings } from "@mui/icons-material";
// import { useLocation } from "react-router-dom";

// // Import your Posts component
// import JobsLive from "../pages/JobsLive"; // Adjust the path according to your file structure
// import ResumeScreeingCandidates from "../pages/ResumeScreening/ResumeScreeingCandidates";
// import Assessments from "../pages/Assessments/MyAssessments";
// import InterviewAssessments from "./Assessments/InterviewAssessments";
// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// function a11yProps(index) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }

// const TabPage = () => {
//   const [value, setValue] = useState(0);
//   const location = useLocation();

//   // Get company ID from location state
//   const companyId = location.state?.companyId;
//   const company = location.state?.company;
//   console.log("companyId", companyId);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   return (
//     <Container
//       maxWidth={false}
//       sx={{
//         mt: 4,
//         mb: 4,
//         ml: { xs: 0, md: "230px" },
//         maxWidth: "calc(100vw - 270px)", // Wider container
//         width: "100%",
//       }}
//     >
//       <Paper elevation={3} sx={{ borderRadius: 2, width: "100%" }}>
//         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//           <Tabs
//             value={value}
//             onChange={handleChange}
//             aria-label="basic tabs example"
//             variant="fullWidth"
//             sx={{
//               "& .MuiTab-root": {
//                 fontWeight: 500,
//                 fontSize: "1rem",
//                 textTransform: "none",
//                 py: 2,
//                 minWidth: "200px", // Minimum width for each tab
//                 px: 4, // More horizontal padding
//               },
//               "& .MuiTabs-flexContainer": {
//                 justifyContent: "space-around", // Better spacing
//               },
//             }}
//           >
//             <Tab
//               icon={<Dashboard />}
//               label="Live Jobs"
//               iconPosition="start"
//               {...a11yProps(0)}
//             />
//             <Tab
//               icon={<Settings />}
//               label="My Assessments"
//               iconPosition="start"
//               {...a11yProps(1)}
//             />
//           </Tabs>
//         </Box>

//         {/* Tab Panels */}
//         <TabPanel value={value} index={0}>
//           {/* Live Jobs Tab - Pass companyId to JobsLive component */}
//           <JobsLive companyId={companyId} company={company} />
//           {/* <ResumeScreeingCandidates companyId={companyId} company={company} /> */}
//         </TabPanel>

//         <TabPanel value={value} index={1}>
//           {/* My Assessments Tab */}
//           <Assessments companyId={companyId} company={company} />
//         </TabPanel>
//       </Paper>
//     </Container>
//   );
// };

// export default TabPage;

import React, { useState } from "react";
import { Box, Tabs, Tab, Typography, Paper, Container } from "@mui/material";
import { Dashboard, Settings } from "@mui/icons-material";

// Import your Posts component
import JobsLive from "../pages/JobsLive";
import ResumeScreeingCandidates from "../pages/ResumeScreening/ResumeScreeingCandidates";
import Assessments from "../pages/Assessments/MyAssessments";
import InterviewAssessments from "./Assessments/InterviewAssessments";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TabPage = ({ companyData }) => {
  const [value, setValue] = useState(0);

  // Extract companyId and company from props
  const companyId = companyData?.companyId;
  const company = companyData?.company;

  console.log("companyId:", companyId);
  console.log("company:", company);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Show loading state until data is available
  if (!companyData) {
    return (
      <Container
        maxWidth={false}
        sx={{
          mt: 4,
          mb: 4,
          ml: { xs: 0, md: "230px" },
          maxWidth: "calc(100vw - 270px)",
          width: "100%",
        }}
      >
        <Paper elevation={3} sx={{ borderRadius: 2, width: "100%", p: 3 }}>
          <Typography>Loading company data...</Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container
      maxWidth={false}
      sx={{
        mt: 4,
        mb: 4,
        ml: { xs: 0, md: "230px" },
        maxWidth: "calc(100vw - 270px)",
        width: "100%",
      }}
    >
      <Paper elevation={3} sx={{ borderRadius: 2, width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="fullWidth"
            sx={{
              "& .MuiTab-root": {
                fontWeight: 500,
                fontSize: "1rem",
                textTransform: "none",
                py: 2,
                minWidth: "200px",
                px: 4,
              },
              "& .MuiTabs-flexContainer": {
                justifyContent: "space-around",
              },
            }}
          >
            <Tab
              icon={<Dashboard />}
              label="Live Jobs"
              iconPosition="start"
              {...a11yProps(0)}
            />
            <Tab
              icon={<Settings />}
              label="My Assessments"
              iconPosition="start"
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>

        {/* Tab Panels */}
        <TabPanel value={value} index={0}>
          <JobsLive companyId={companyId} company={company} />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <Assessments companyId={companyId} company={company} />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default TabPage;
